import { AuthToken, TemporaryTokenManager } from '@cobliteam/api-lib';
import { SessionManager } from '@cobliteam/api-lib/src/account/session';
import { Location, type Session } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments/src/Environments';
import { locationChange } from '@cobliteam/store/src/Location/actionCreators';
import { loginSucceeded, logoutFailed, logoutSucceeded, updateAccountFailed, updateAccountSucceeded } from '@cobliteam/store/src/Login/actionCreators';
import type { UserFleetChangeRequest, UserInfoUpdateRequest } from '@cobliteam/store/src/Login/actions';
import { LoginActionTypes } from '@cobliteam/store/src/Login/actionTypes';
import Alert from '@cobliteam/ui/components/Alert';
import { clear } from 'idb-keyval';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { queryClient } from '../../../Dashboard';

const env = Environment.getInstance().getEnvironment();
const sessionManager = new SessionManager({ host: env.herbieApiHost });

/** END LOGIN SEQUENCE */
export function* requestLogoutSaga() {
  try {
    locationChange(Location.LOGIN);

    // clear all queries
    queryClient.removeQueries();

    // clear all indexedDB
    yield call(clear);

    yield call(sessionManager.logout);

    yield put(logoutSucceeded());
  } catch (err) {
    Alert.error('Houve um erro ao efetuar o logout, recarregue a página e tente novamente.');
    yield put(logoutFailed());
  }
}

export function* requestSessionSaga() {
  try {
    if (localStorage.getItem(AuthToken.REFRESH_TOKEN)) {
      const session: Session = yield call(sessionManager.getSession);
      yield put(loginSucceeded(session));
    } else {
      yield put(logoutSucceeded());
    }
  } catch (err) {
    yield put(logoutSucceeded());
  }
}

export function* requestUpdateAccountSaga(action: UserInfoUpdateRequest) {
  try {
    const session: Session = yield call(sessionManager.update, action.payload);
    yield put(updateAccountSucceeded(session));
    Alert.success('Dados alterados com sucesso');
  } catch (err) {
    yield put(updateAccountFailed());
    Alert.error('Erro. Tente novamente.');
  }
}

export function* changeUserFleetSaga(action: UserFleetChangeRequest) {
  try {
    const userFleet = action.payload;
    yield call(sessionManager.changeUserLoggedFleet, userFleet);
    TemporaryTokenManager.deleteTemporaryToken();
    window.location.href = '/';
  } catch (err) {
    Alert.error('Houve um erro ao tentar trocar de frota');
  }
}

export function* LoginSagasListener() {
  yield all([
    takeLatest(LoginActionTypes.CHANGE_USER_FLEET_REQUEST, changeUserFleetSaga),
    takeLatest(LoginActionTypes.LOGOUT_REQUEST, requestLogoutSaga),
    takeLatest(LoginActionTypes.SESSION_REQUEST, requestSessionSaga),
    takeLatest(LoginActionTypes.UPDATE_ACCOUNT_REQUEST, requestUpdateAccountSaga),
  ]);
}
